import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { format, subDays, subMonths, addDays, addMonths } from 'date-fns'
import { useFormContext } from 'react-hook-form'
import { DatePickerContext } from '../DatePickerProvider'
import StateIcon from 'components/global/StateIcon'
import {
  PresetContainer,
  PresetHeader,
  StyledRadioGroup,
  StyledFormControlLabel,
  StyledRadio
} from './PresetDate.styles'

const PRESET_OPTIONS = [
  { key: 'today', days: 0 },
  { key: 'last7days', days: 7 },
  { key: 'last15days', days: 15 },
  { key: 'last30days', days: 30 },
  { key: 'last3months', months: 3 },
  { key: 'last6months', months: 6 },
  { key: 'last12months', months: 12 }
]

export const PresetDates = () => {
  const { t } = useTranslation()
  const { setValue, watch } = useFormContext()
  const { setDateNameSelected, locale, blockPastDates, blockFutureDates } = useContext(DatePickerContext)

  const isPresetDisabled = (preset) => {
    if (blockPastDates) {
      if (preset.days > 0) return true
      if (preset.months) return true
    }

    if (blockFutureDates) {
      if (preset.days < 0) return true
      if (preset.months && preset.months < 0) return true
    }

    return false
  }

  const handlePresetChange = (preset) => {
    const today = new Date()
    let startDate = today
    let endDate = today

    if (preset.days !== undefined) {
      if (preset.days > 0) {
        startDate = subDays(today, preset.days)
      } else if (preset.days < 0) {
        endDate = addDays(today, Math.abs(preset.days))
      }
    } else if (preset.months) {
      if (preset.months > 0) {
        startDate = subMonths(today, preset.months)
      } else {
        endDate = addMonths(today, Math.abs(preset.months))
      }
    }    

    setValue('startDate', format(startDate, 'P', { locale }))
    setValue('endDate', format(endDate, 'P', { locale }))
    setValue('presetSelection', preset.key)
    setDateNameSelected('endDate')
  }

  return (
    <PresetContainer>
      <PresetHeader>{t('datepicker.headers.preset')}</PresetHeader>
      <StyledRadioGroup value={watch('presetSelection')}>
        {PRESET_OPTIONS.map((option) => (
          <StyledFormControlLabel
            key={option.key}
            value={option.key}
            disabled={isPresetDisabled(option)}
            isselected={watch('presetSelection') === option.key ? 1 : 0}
            control={
              <StyledRadio
                icon={<StateIcon iconweight="light" iconlabel="circle" iconcolor="text.body.tertiary" />}
                checkedIcon={<StateIcon iconlabel="check-circle" sx={{ color: 'primary.main' }} />}
                checked={watch('presetSelection') === option.key}
              />            
            }
            label={t(`datepicker.presets.${option.key}`)}
            onChange={() => handlePresetChange(option)}
          />
        ))}
      </StyledRadioGroup>
    </PresetContainer>
  )
}
